import React from 'react';

import Modal from '~/commons/components/Modal.jsx';

const ModalAnsConfirm = ({
  show,
  onReject = () => {},
  onConfirm = () => {},
}) => (
  <Modal
    show={show}
    onHide={onReject}
    centered
  >
    <div className="text-center p-4">
      <h4>提交答案後就無法修改啊！</h4>
      <h4>確定提交答案？</h4>
      <div className="mt-4">
        <button
          onClick={onReject}
          className="m-2 btn btn-tertiary"
        >
          謹慎一點，再看一遍!
        </button>
        <button
          onClick={onConfirm}
          className="m-2 btn btn-outline-tertiary"
        >
          很有信心，確定提交!
        </button>
      </div>
    </div>
  </Modal>
);

export default ModalAnsConfirm;
